import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { ToastContainer, Slide } from 'react-toastify';
import './App.scss';
import Http from 'utils/http';
import Keycloak from 'keycloak-js';

// import MKToasty from 'components/mktoasty';

// Containers
import { DefaultLayout } from './containers';

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      keycloak: null,
      authenticated: false
    };
  }

  componentDidMount = () => {
    const keycloak = Keycloak(window.KEYCLOAK);

    keycloak.init({ onLoad: 'login-required', checkLoginIframe: false }).success(authenticated => {
      this.setState({ keycloak: keycloak, authenticated: authenticated });
    });

    Http.addRequestInterceptor(config => {
      return new Promise((resolve, reject) => {

        return keycloak.updateToken(30)
          .success(() => {
            config.headers.Authorization = 'Bearer ' + keycloak.token;
            return resolve(config)
          }).error(error => {
            keycloak.login();
            return reject(error)
          });

      });

    });

  }

  renderApp() {
    return (
      <div>
        <HashRouter>
          <Switch>
            <Route path="/" name="Home" render={props => (
              <DefaultLayout {...props} keycloak={this.state.keycloak} />
            )} />
          </Switch>
        </HashRouter>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange={false}
          draggable={false}
          pauseOnHover
          transition={Slide}
        />
        {/* <MKToasty timeout={1000 * 60 * 10} ramdom={true} loop={true} /> */}
      </div >
    );
  }

  render() {

    if (this.state.keycloak) {
      if (this.state.authenticated) {
        return this.renderApp();
      } else {
        return (<div>Unable to authenticate!</div>)
      }
    }
    return (<div>Loading...</div>);
  }

}

export default App;
